const doc = [({"en":({"js":({"admin":({"tenants":({"nav":({"integrations":"Integrations"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;